import axios from 'axios';
import store from '../index';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const state = {
	address: {},
};

const getters = {
	getAddress: state => {
		return state.address;
	},
};

const actions = {
	searchAddress: async (context, payload) => {
		let url = 'googlemaps';

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						address: payload.address,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data.data;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	destroyData: context => {
		context.commit('setAddress', {});
	},
};

const mutations = {
	setAddress: (state, value) => {
		state.address = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
